import { Link, useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '../../ui/button';

export interface DefaultErrorPageProps {
  error: unknown;
  /** Whether the app is running in development mode. When true, shows the error message. */
  isDev?: boolean;
}

export function DefaultErrorPage({ error, isDev = false }: DefaultErrorPageProps): React.JSX.Element {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-4xl font-bold">{t('errors.unexpected.title')}</h1>
      <p className="text-muted-foreground">{t('errors.unexpected.description')}</p>
      {isDev && (
        <pre className="mt-4 max-w-lg overflow-auto rounded bg-destructive/10 p-4 text-start text-sm text-destructive">
          {error instanceof Error ? error.message : String(error)}
        </pre>
      )}
      <div className="flex gap-2">
        <Button onClick={() => router.invalidate()} variant="outline">
          {t('errors.retry')}
        </Button>
        <Button asChild>
          <Link to="/">{t('errors.goHome')}</Link>
        </Button>
      </div>
    </div>
  );
}
